var $ = require( "jquery" );
window.jQuery = $; window.$ = $;
import 'simplebar';
import 'simplebar/dist/simplebar.css';
import ResizeObserver from 'resize-observer-polyfill';
window.ResizeObserver = ResizeObserver;

// Mobile Nav
(function() {
	$('#nav-icon3').click(function(){
		$('body').toggleClass('no-scroll');
		$(this).toggleClass('open');
		// $('.header-menu').slideToggle();
		$('.menu').slideToggle();
		$('#mobile-nav').toggleClass('scroll');
		$('.isi-sticky').toggleClass('hidden');
	});

	$('.header-menu .menu-item-has-children').append('<span class="open-menu"><div>&#9662;</div></span>'); 
	$('.open-menu').click(function() {
		$(this).find('div').toggleClass('rotate')
		$(this).parent().toggleClass('active')
		$(this).prev('.sub-menu').toggleClass('active');
		$(this).parent().prevAll().find('.sub-menu').removeClass('active');
		$(this).parent().nextAll().find('.sub-menu').removeClass('active');
	})
})();

// Toggle Tab Footer
(function() {
	$('.isi-sticky .view-more').on('click', function() {
		$('.isi-sticky').toggleClass('on');
		$('body').toggleClass('no-scroll');
	})
})();

// Scroll
(function() {
	var $scrollTrigger = $('.isi');
  var isiStickyHeight = $('.isi-sticky').height();

  $(window).on('resize', function() {
    isiStickyHeight = $('.isi-sticky').height();
  });
  
  $(window).on('scroll', function() {
    var windowBottom = $(window).scrollTop() + $(window).height();
    var triggerTop = $scrollTrigger.offset().top + isiStickyHeight;
    var triggerBottom = $scrollTrigger.offset().top + $scrollTrigger.height();

    if (windowBottom >= triggerTop) {
      $('.isi-sticky').addClass('hidden');
    } else {
      $('.isi-sticky').removeClass('hidden');
    }
  });
})();

// Nav hide on scroll-down, show on scroll-up
(function() {
	var previousScroll = 0;
  var $navbar = $('header');
  var $stickybar = $('.js-sticky-nav');
  var stickyPresent;

  $(window).scroll(function() {
    var currentScroll = $(window).scrollTop();
    if ($stickybar.length > 0) {
      stickyPresent = true;
    }

    if (currentScroll > previousScroll) {
      // Scrolling down, hide the navigation
      $navbar.css('top', -$navbar.height() + 'px');
      $('body').addClass('scrolling-down');
      if (stickyPresent) {
        $stickybar.css('top', '0px');
      }
    } else {
      // Scrolling up, show the navigation
      $navbar.css('top', '0');
      $('body').removeClass('scrolling-down');
      if (stickyPresent) {
        $stickybar.css('top', $navbar.height() + 'px');
      }
    }

    previousScroll = currentScroll;
  });
})();

// ISI Sticky
(function() {
	$('.tabs-footer').find('.btn').on('click', function() {
		$(this).toggleClass('active');
		$(this).parent().next().slideToggle();
		$(this).parent().parent().toggleClass('bg-color');
	})
})();
(function() {
	$('.tabs-footer').find('.button').on('click', function() {
		$(this).toggleClass('active');
		$(this).parent().next().slideToggle();
		$(this).parent().parent().toggleClass('bg-color');
	})
})();


// Accordion Trigger
(function() {
  $('.accordion-header').click(function() {
    $(this).toggleClass('active');
    $(this).next('.accordion-content').slideToggle();
  });
})();


// Terms Modal Trigger
(function() {
  $('#terms-modal-btn').click(function() {
    $('#terms-modal').removeClass('hidden');
    $('body').addClass('scroll-lock');
  });
})();
(function() {
  $('#terms-modal button').click(function() {
    $('#terms-modal').addClass('hidden');
    $('body').removeClass('scroll-lock');
  });
})();

// Video Thumbnail Switch
(function() {
  $('.video-poster').click(function() {
    var iframe = document.querySelector('iframe');
    var player = new Vimeo.Player(iframe);
    player.play();
    $('.video iframe').removeClass('hidden');
  });
})();

// Sub page link scrolling
var offsetHeight = 0;
var hideNav = false;
(function() {
  // Check for direct link traffic
  if (location.hash) {
    setTimeout(function() {
      $(document).ready(function() {
        // Close all accordions
        $('.accordion-wrapper .accordion-header').each(function() {
          if ($(this).hasClass('active')) {
            $(this).removeClass('active');
          }
        });
        $('.accordion-wrapper .accordion-content').each(function() {
          if ($(this).hasClass('block')) {
            $(this).removeClass('block');
          }
        });
        // Open new accordion
        $(location.hash + ' .accordion-header').addClass('active');
        $(location.hash + ' .accordion-content').addClass('block');
        // Cookies offset
        offsetHeight = $('body').css('padding-top');
        offsetHeight = offsetHeight.substring(0, offsetHeight.length - 2);
        // Scroll page
        $('html, body').animate({
          scrollTop: $(location.hash).offset().top - offsetHeight
        }, 100, function() {
          // Nav offset
          setTimeout(function() {
            $('header').css('top', '-1000px');
          }, 50);
          
        });
      });
    }, 1);
  }
  // Subpage link clicked
  $(document).ready(function() {
    $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
      // Close nav menu
      if ($('#mobile-nav').hasClass('scroll')) {
        $('#nav-icon3').click();
      }
      // Open new accordion
      $(this.hash + ' .accordion-header').addClass('active');
      $(this.hash + ' .accordion-content').addClass('block');
      // Cookies offset
      offsetHeight = $('body').css('padding-top');
      offsetHeight = offsetHeight.substring(0, offsetHeight.length - 2);
      // On-page links
      if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - offsetHeight
          }, 1000, function() {
            // Callback after animation
            // Nav hide
            setTimeout(function() {
              $('header').css('top', '-1000px');
            }, 50);
            
          });
        }
      }
    });
  });
})();

// Cookie Section
(function() {	
  $(document).ready(function() {
      // Function to check visibility
      function checkDivVisibility() {
	      	function setTargetHeight() {
	            var cookieBarHeight = $("#cookie-law-info-bar").outerHeight();
	            $('body').css('padding-top', cookieBarHeight);
	        }
          if ($("#cookie-law-info-bar").is(":visible")) {
			        setTargetHeight()
          } else {
              $('body').css('padding-top', 0);
          }

          $(window).resize(function() {
            // setTargetHeight();
            if ($("#cookie-law-info-bar").is(":visible")) {
			        setTargetHeight()
	          } else {
	              $('body').css('padding-top', 0);
	          }
        });
      }

      // Check visibility on page load
      checkDivVisibility();

      // Check visibility on button click
      $("#wt-cli-accept-all-btn").click(function() {
          $('body').css('padding-top', 0);          
      });
  });
})();

/**
* jquery.matchHeight-min.js v0.5.2
* http://brm.io/jquery-match-height/
* License: MIT
*/
(function(b){b.fn.matchHeight=function(a){if("remove"===a){var d=this;this.css("height","");b.each(b.fn.matchHeight._groups,function(b,a){a.elements=a.elements.not(d)});return this}if(1>=this.length)return this;a="undefined"!==typeof a?a:!0;b.fn.matchHeight._groups.push({elements:this,byRow:a});b.fn.matchHeight._apply(this,a);return this};b.fn.matchHeight._apply=function(a,d){var c=b(a),e=[c];d&&(c.css({display:"block","padding-top":"0","padding-bottom":"0","border-top-width":"0","border-bottom-width":"0",
height:"100px"}),e=k(c),c.css({display:"","padding-top":"","padding-bottom":"","border-top-width":"","border-bottom-width":"",height:""}));b.each(e,function(a,c){var d=b(c),e=0;d.each(function(){var a=b(this);a.css({display:"block",height:""});a.outerHeight(!1)>e&&(e=a.outerHeight(!1));a.css({display:""})});d.each(function(){var a=b(this),c=0;"border-box"!==a.css("box-sizing")&&(c+=g(a.css("border-top-width"))+g(a.css("border-bottom-width")),c+=g(a.css("padding-top"))+g(a.css("padding-bottom")));
a.css("height",e-c)})});return this};b.fn.matchHeight._applyDataApi=function(){var a={};b("[data-match-height], [data-mh]").each(function(){var d=b(this),c=d.attr("data-match-height");a[c]=c in a?a[c].add(d):d});b.each(a,function(){this.matchHeight(!0)})};b.fn.matchHeight._groups=[];b.fn.matchHeight._throttle=80;var h=-1,f=-1;b.fn.matchHeight._update=function(a){if(a&&"resize"===a.type){a=b(window).width();if(a===h)return;h=a}-1===f&&(f=setTimeout(function(){b.each(b.fn.matchHeight._groups,function(){b.fn.matchHeight._apply(this.elements,
this.byRow)});f=-1},b.fn.matchHeight._throttle))};b(b.fn.matchHeight._applyDataApi);b(window).bind("load resize orientationchange",b.fn.matchHeight._update);var k=function(a){var d=null,c=[];b(a).each(function(){var a=b(this),f=a.offset().top-g(a.css("margin-top")),h=0<c.length?c[c.length-1]:null;null===h?c.push(a):1>=Math.floor(Math.abs(d-f))?c[c.length-1]=h.add(a):c.push(a);d=f});return c},g=function(a){return parseFloat(a)||0}})(jQuery);


$('.equal').matchHeight();

